import { ApiResponse } from './api'
import type { ApiClient } from './api/ApiClient'
import { ServiceBase } from './api/ServiceBase'

/**
 * 今日统计数据响应模型
 * 本日統計データレスポンスモデル
 * Daily Statistics Response Model
 */
export interface DailyStatisticsResponse {
  /**
   * 今日入库件数
   * 本日入庫件数
   * Today's inbound count
   */
  todayInbound: number

  /**
   * 今日出库件数
   * 本日出庫件数
   * Today's outbound count
   */
  todayOutbound: number

  /**
   * 库存总件数
   * 在庫総件数
   * Total stock count
   */
  totalStock: number

  /**
   * 未处理件数
   * 未処理件数
   * Pending count
   */
  pendingCount: number

  /**
   * 统计日期(JST时区)
   * 統計日付(JSTタイムゾーン)
   * Statistics date (JST timezone)
   */
  today: string
}

// 托盘绑定库位请求接口
export interface BindPositionRequest {
  position_code: string
}

export class StatisticsV2Service extends ServiceBase {
  constructor(client: ApiClient) {
    super(client, '/v2/statistics')
  }

  /**
   * 获取每日统计数据
   * 毎日統計データを取得
   * Get daily statistics
   */
  async daily() {
    return this.get<ApiResponse<DailyStatisticsResponse>>(`/daily`)
  }
}

export default StatisticsV2Service
